import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ViewDataStatistics } from "components/containers/dashboard/dataStatistics/ViewComponent";
import { typeStatisticsState } from "model/dashboardStatistics/dStatisticsReducer";
import { dStatisticsSetDailyDataSagaAC } from "model/dashboardStatistics/dStatisticsActionCreators";
import { Loader } from "../../../UI/Loader/Loader";

// Type
export type typeStatistics = {
  variant?: string;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export type typeDataStatisticsRowActions = {
  title: React.JSX.Element;
  action: (id: string) => void;
}[];

export enum dateFilterValues {
  TODAY = "today",
  YESTERDAY = "yesterday",
  WEEK = "week",
  MONTH = "month",
  PERIOD = "period",
}

// Utils
export const toStringDate = (date: Date) => {
  const year: string = String(date.getFullYear());
  const monthDate = date.getMonth() + 1;
  const month: string =
    monthDate > 9 ? String(monthDate) : "0" + String(monthDate);
  const dayDate = date.getDate();
  const day: string = dayDate > 9 ? String(dayDate) : "0" + String(dayDate);
  return year + "-" + month + "-" + day;
};

const toStringPeriod = (dateFrom: Date, dateTo: Date) => {
  let stringPeriod = "";
  if (
    dateFrom.toLocaleString(undefined, {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    }) ===
    dateTo.toLocaleString(undefined, {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    })
  ) {
    stringPeriod = dateFrom.toLocaleString(undefined, {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    });
  } else {
    stringPeriod =
      dateFrom.toLocaleString(undefined, {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
      }) +
      " - " +
      dateTo.toLocaleString(undefined, {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
      });
  }
  return stringPeriod;
};

// Component
const DataStatisticsIndex: React.FC<typeStatistics> = ({
  variant,
  setSidebarOpen,
}) => {
  const dispatch = useDispatch();

  // System data
  const period = useSelector(
    (state: { dStatistics: typeStatisticsState }) => state.dStatistics.period,
  );

  const loaderDaily = useSelector(
    (state: { dStatistics: typeStatisticsState }) =>
      state.dStatistics.loaderDaily,
  );
  const loaderFilter = useSelector(
    (state: { dStatistics: typeStatisticsState }) =>
      state.dStatistics.loaderFilter,
  );

  const hoursStatistic = useSelector(
    (state: { dStatistics: typeStatisticsState }) =>
      state.dStatistics.hoursData,
  );
  const weekDayStatistic = useSelector(
    (state: { dStatistics: typeStatisticsState }) =>
      state.dStatistics.weekDayData,
  );
  const paymentMethodAmountStatistic = useSelector(
    (state: { dStatistics: typeStatisticsState }) =>
      state.dStatistics.paymentMethodAmountData,
  );
  const paymentMethodCountStatistic = useSelector(
    (state: { dStatistics: typeStatisticsState }) =>
      state.dStatistics.paymentMethodCountData,
  );
  const saleTypeAmountStatistic = useSelector(
    (state: { dStatistics: typeStatisticsState }) =>
      state.dStatistics.paymentTypeAmountData,
  );
  const saleTypeCountStatistic = useSelector(
    (state: { dStatistics: typeStatisticsState }) =>
      state.dStatistics.paymentTypeCountData,
  );
  const employeeStatistic = useSelector(
    (state: { dStatistics: typeStatisticsState }) =>
      state.dStatistics.employeeData,
  );
  const productStatistic = useSelector(
    (state: { dStatistics: typeStatisticsState }) =>
      state.dStatistics.productData,
  ).slice(0, 5);

  // String period
  const dateFrom = new Date(period.dateFrom);
  const dateTo = new Date(period.dateTo);
  let stringPeriod = toStringPeriod(dateFrom, dateTo);

  let todayFrom = new Date();
  todayFrom.setHours(0, 0, 0, 0);
  let todayTo = new Date();
  todayTo.setHours(23, 59, 59, 999);

  useEffect(() => {
    toStringDate(todayFrom);
    dispatch(
      dStatisticsSetDailyDataSagaAC({
        storeIds: [],
        dateFrom: toStringDate(todayFrom),
        dateTo: toStringDate(todayTo),
      }),
    );
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {
        <ViewDataStatistics
          variant={variant}
          setSidebarOpen={setSidebarOpen}
          loaderDaily={loaderDaily}
          loaderFilter={loaderFilter}
          stringPeriod={stringPeriod}
          hoursStatistic={hoursStatistic}
          weekDayStatistic={weekDayStatistic}
          paymentMethodAmountStatistic={paymentMethodAmountStatistic}
          paymentMethodCountStatistic={paymentMethodCountStatistic}
          saleTypeAmountStatistic={saleTypeAmountStatistic}
          saleTypeCountStatistic={saleTypeCountStatistic}
          employeeStatistic={employeeStatistic}
          productStatistic={productStatistic}
        />
      }
    </>
  );
};

// TODO:: Delete after refactoring ( in the future we will get statistics from clickhouse )
export const DataStatistics: React.FC<typeStatistics> = (props) => {
  const [loading, setLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    let reject: (reason?: any) => void | undefined;
    (async () => {
      new Promise((acc, rej) => {
        reject = rej;

        setTimeout(() => {
          acc(true);
        }, 3000);
      }).then(() => setLoading(false));
    })();

    return function () {
      if (typeof reject === "function") {
        reject(false);
      }
    };
  }, []);

  if (loading) {
    return <Loader />;
  }

  return <DataStatisticsIndex {...props} />;
};
